class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.url = this.querySelector("a").getAttribute("href");
    this.product = this.dataset.product;
    this.dialog = this.querySelector("product-dialog");
    this.actions = this.querySelectorAll("button");
    this.backdrop = document.querySelector("[data-backdrop]");
  }

  connectedCallback() {
    this.url.includes("?")
      ? (this.url = `${this.url}&section_id=product-dialog`)
      : (this.url = `${this.url}?section_id=product-dialog`);

    this.actions.forEach((action) => {
      switch (action.dataset.action) {
        case "open-dialog":
          action.addEventListener("click", this.openDialog.bind(this));
          break;
        case "close-dialog":
          action.addEventListener("click", this.closeDialog.bind(this));
          break;
      }
    });

    this.backdrop.addEventListener("click", this.closeDialog.bind(this));
  }

  openDialog() {
    this.dialog.setAttribute("data-active", "");
    this.actions[0].disabled = true;

    this.backdrop.setAttribute("data-active", "");
    freezeBody(true);

    if (!this.dialog.querySelector("[data-dynamic-product-dialog-content]")) {
      this.fetchProductDialog().then(() => {
        this.initDialogScripts();
        this.initVariantPrices();
      });
    } else {
      this.initDialogScripts();
      this.initVariantPrices();
    }
  }

  closeDialog() {
    this.dialog.removeAttribute("data-active");
    this.actions[0].disabled = false;
    this.backdrop.removeAttribute("data-active");
    freezeBody(false);
  }

  async fetchProductDialog() {
    return fetch(this.url)
      .then((response) => response.text())
      .then((html) => {
        const product_dialog = new DOMParser().parseFromString(html, "text/html");
        this.dialog.querySelector("[data-product-dialog-content]").outerHTML =
          product_dialog.body.firstChild.firstElementChild.innerHTML;
        freezeBody(true);
      });
  }

  initDialogScripts() {
    const scope = this.dialog;

    setupMultiBuyOptionsNew(scope);
    setupBuyOneOptionToggleNew(scope);
    setupSubsBuyOnceToggle(scope);

    document.dispatchEvent(new CustomEvent("setupMultiBuyOptions:init", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("autoCheckFirstSellingPlan:init", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("setupBuyOneOptionToggle:init", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("autoSelectSubOption:init", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("setupProductCardButtonClick:init", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("setupFeatureToggleListeners:init", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("setupMultiBuyOptions-new:init", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("setupBuyOneOptionToggle-new:init", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("setupSubsBuyOnceToggle:init", { detail: { scope } }));
  }

  // ===== Variant price update logic =====
initVariantPrices() {
  const scope = this.dialog;


  // Add variant change listeners
  scope.querySelectorAll('input[data-change="variant"][data-price]').forEach(radio => {
    // Update prices
    radio.addEventListener('change', () => {
      updatePrices(radio, scope);
      updateCheckedStyles(scope);
    });
  });

  const input = scope.querySelector('.sub-option input[type="radio"]');

  if (input) {
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    console.log("Subscription option clicked:", input.id);
    
    // Scroll dialog box to top after auto-checking selling plan
    requestAnimationFrame(() => {
      const dialogBox = scope.querySelector('.product-dialog-box');
      const dialogWrapper = scope.querySelector('.product-dialog-main-wrapper');
      if (dialogBox && dialogWrapper) {
        dialogBox.scrollTop = 0;
        dialogWrapper.scrollTop = 0;
      }
    });
  } else {
    console.log("Input not found inside scope");
  }

  // Run on load for checked variant
  const selectedRadio = scope.querySelector('input[data-change="variant"][data-price]:checked');
  if (selectedRadio) {
    updatePrices(selectedRadio, scope);
    updateCheckedStyles(scope);
  }
}

}

// ===== Global updatePrices function =====
function updatePrices(radio, scope = document) {
  if (!radio) return;

  const oneTimePriceContainer = scope.querySelector('[js-onetime-price]');
  const oneTimeCompareContainer = scope.querySelector('[js-onetime-compare]');
  const subsContainer = scope.querySelector('[js-subs-price]');
  const currentPriceContainer = scope.querySelector('[js-current-price]');
  const subsDiscountContainer = scope.querySelector('[js-subs-discount]');
  const buyDiscountContainer = scope.querySelector('[js-buy-discount]');

  const oneTimePrice = radio.getAttribute('data-price');
  const comparePrice = radio.getAttribute('data-compare-price');
  const subsPrice = radio.getAttribute('data-subs-price');
  const subsDiscount = radio.getAttribute('data-discount');
  const buyOnceDiscount = radio.getAttribute('data-buy-once-dis');

  if (oneTimePriceContainer) oneTimePriceContainer.innerHTML = oneTimePrice || "";
  if (oneTimeCompareContainer) {
    if (comparePrice && comparePrice !== oneTimePrice) {
      oneTimeCompareContainer.innerHTML = comparePrice;
      oneTimeCompareContainer.style.display = "inline-block";
    } else {
      oneTimeCompareContainer.innerHTML = "";
      oneTimeCompareContainer.style.display = "none";
    }
  }
  if (subsContainer) subsContainer.innerHTML = subsPrice || "";
  if (currentPriceContainer) currentPriceContainer.innerHTML = oneTimePrice || "";

  if (subsDiscountContainer) {
    if (subsDiscount) {
      subsDiscountContainer.innerHTML = `Save ${subsDiscount}`;
      subsDiscountContainer.style.display = "inline-block";
    } else {
      subsDiscountContainer.innerHTML = "";
      subsDiscountContainer.style.display = "none";
    }
  }

  if (buyDiscountContainer) {
    if (buyOnceDiscount) {
      buyDiscountContainer.innerHTML = `Save ${buyOnceDiscount}`;
      buyDiscountContainer.style.display = "inline-block";
    } else {
      buyDiscountContainer.innerHTML = "";
      buyDiscountContainer.style.display = "none";
    }
  }
}

customElements.define("product-card", ProductCard);
